export default ".mandatory {\n  color: red;\n}";